import { render, staticRenderFns } from "./MembershipForm.vue?vue&type=template&id=0a8b107d&scoped=true&"
import script from "./MembershipForm.vue?vue&type=script&lang=js&"
export * from "./MembershipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8b107d",
  null
  
)

export default component.exports